import { render } from "./FinancialPledgesReport.vue?vue&type=template&id=f2a37814&scoped=true"
import script from "./FinancialPledgesReport.vue?vue&type=script&lang=js"
export * from "./FinancialPledgesReport.vue?vue&type=script&lang=js"

import "./FinancialPledgesReport.vue?vue&type=style&index=0&id=f2a37814&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f2a37814"]])

export default __exports__